var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file_viewer"},[_vm._v(" Fichier consultation:"),_c('br'),_c('vs-divider'),_c('iframe',{staticClass:"w-full",attrs:{"src":_vm.path,"height":"700","frameBorder":"0"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }